/**
 * Transformer that is triggered when an item was removed by the user
 * and a previous item has been loaded.
 * It allows to hide a custom spinner which is displayed while this previous item
 * loading is in progress.
 */
export default (kasko) => {
  kasko.addEventListener('item-loaded', () => {
    if (kasko.getState('input.is_remove_item_modal') !== 'closed') {
      kasko.dispatchEvent('set-state-input', {
        is_remove_item_modal: 'closed',
      });
    }
  });
};
